import styled from 'styled-components'

export const Container = styled.div<{ padding?: string }>`
  padding: ${props => props.padding ?? '0px'};
`
